export default {
  SET_VISIBILITY: 'setVisibility',
  SET_CONTENT: 'setContent',
};
